import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import GalleryCard from "../../Components/Gallery/GalleryCard";
import { connect } from "react-redux";
import axios from "axios";
import noData from "../../Assets/img/noData.png";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Button, Accordion } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      fakeData: [1, 2, 3],
      photoIndex: 0,
      isOpen: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Gallery";
    this.fetchGallery({ session: this.props?.user?.session?.id });
  }

  fetchGallery = (params = {}) => {
    axios
      .get("/mApiV1/SchoolGalleryList", { params: { ...params } })
      .then((res) => {
        console.log(res, "res res");
        this.setState({ data: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    let { data, photoIndex, isOpen } = this.state;
    console.log(data[0], "Edceffcecfe");
    return (
      <div>
        <Header to="/home" title="Gallery" />
        <div className="container pt-3 col-12">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div key={index}>
                    <GalleryCard loading={this.state.loading} />
                  </div>
                );
              })
            : null}

          {this.state.data.length !== 0 && this.state.loading === false
            ? this.state?.data?.map((item, index) => {
                return (
                  <div key={index}>
                    <div
                      onClick={() =>
                        this.setState({
                          photoIndex: index % data.length,
                          isOpen: !this.state.isOpen,
                        })
                      }
                    >
                      {" "}
                      <GalleryCard img={item?.upload_gallery} />
                    </div>
                    <div className="p-2">
                      <Accordion defaultActiveKey={null}>
                        <div>
                          <Accordion.Toggle
                            as={Button}
                            variant="link"
                            eventKey="1"
                            style={{
                              padding: 0,
                              textDecoration: "none",
                              boxShadow: "none",
                              width: "100%",
                            }}
                          >
                            {this.state.loading ? (
                              <Skeleton height={25} />
                            ) : (
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <div className="th-14 th-black text-left text-capitalize">
                                    {item.title}
                                  </div>
                                  <div className="th-12 th-grey text-left">
                                    {item.date}
                                  </div>
                                </div>
                                <i
                                  className="fa fa-angle-down th-primary"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            )}
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey="1">
                            <div className="mt-2">
                              <div className="th-12 th-grey text-left text-capitalize">
                                {item.description}
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </div>
                      </Accordion>
                    </div>
                  </div>
                );
              })
            : null}
          {isOpen && (
            <Lightbox
              mainSrc={data[photoIndex]?.upload_gallery}
              nextSrc={data[(photoIndex + 1) % data.length]?.upload_gallery}
              prevSrc={
                data[(photoIndex + data.length - 1) % data.length]
                  ?.upload_gallery
              }
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + data.length - 1) % data.length,
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % data.length,
                })
              }
            />
          )}

          {this.state?.data?.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Images in Gallery!
              </p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Gallery);
